import React from 'react';

import { StyledCustomSelector } from './CustomSelector.styles';

import { CustomSelectorProps } from './CustomSelector.types';

const CustomSelector = ({
  value,
  onSelectorClick = () => {},
  isActive = false,
  componentClassname = 'custom-selector',
  customClassnames = '',
  customStyle = '',
  ...props
}: CustomSelectorProps) => {
  const handleClick = () => {
    onSelectorClick(value, !isActive);
  };

  return (
    <StyledCustomSelector
      className={`${componentClassname} ${customClassnames} ${
        isActive && `${componentClassname}--active ${customClassnames}--active`
      } `}
      customStyle={customStyle}
      onClick={handleClick}
      {...props}
    >
      {value}
    </StyledCustomSelector>
  );
};
CustomSelector.displayName = 'CustomSelector';

export default CustomSelector;
